import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Utilities from "../../dependencies/custom/react-utilities";
import domainSettings from "../../dependencies/custom/settings";

const empty = {
  salary_full: false,
  salary_summary: false,
  tax: false,
  nssf: false,
  bank: false,
  advance: false,
  sacco: false,
  accounting: false,
  allowances_manage: false,
};

export const usePayrollSecurity = () => {
  const navigate = useNavigate();
  const [payrollAccess, setPayrollAccess] = useState(empty);
  const refreshPayrollAccess = useCallback(async () => {
    const response = await Utilities.fetchWithAuth(
      "GET",
      domainSettings.urls.finance.payrollSecurityAccess,
      null,
      navigate,
    );
    if (response.ok) setPayrollAccess({ ...empty, ...response.data });
  }, [navigate]);
  useEffect(() => {
    refreshPayrollAccess();
  }, [refreshPayrollAccess]);
  return { payrollAccess, refreshPayrollAccess };
};
